import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Samuel Orji',
    title: "Software Engineer",
    desciption:"Simple things should be simple, complex things should be possible. ",
    image: 'https://user-images.githubusercontent.com/69601471/184725513-7e8e980a-991e-4c87-adce-204ef31c1a96.jpg',
    resumePdf: resume
}


//There wasn't a bird in the sky, but that was not what caught her attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. She knew what was coming and she hoped she was prepared. 